import api from './api';

class AccountService {
  async getAllAccounts(params = {}) {
    const response = await api.get('/accounts', { params });
    return response.data;
  }

  async getAccount(id) {
    const response = await api.get(`/accounts/${id}`);
    return response.data;
  }

  async lookupAccount(query) {
    const response = await api.get('/accounts/lookup', { params: { q: query } });
    return response.data;
  }

  async createAccount(accountData) {
    const response = await api.post('/accounts', accountData);
    return response.data;
  }

  async deposit(accountId, transactionData) {
    const key = transactionData.idempotency_key || crypto.randomUUID();
    const response = await api.post(`/accounts/${accountId}/deposit`, {
      ...transactionData,
      idempotency_key: key,
    }, {
      headers: { 'X-Idempotency-Key': key }
    });
    return response.data;
  }

  async withdraw(accountId, transactionData) {
    const key = transactionData.idempotency_key || crypto.randomUUID();
    const response = await api.post(`/accounts/${accountId}/withdraw`, {
      ...transactionData,
      idempotency_key: key,
    }, {
      headers: { 'X-Idempotency-Key': key }
    });
    return response.data;
  }

  async getAccountTransactions(accountId, params = {}) {
    const response = await api.get(`/accounts/${accountId}/transactions`, { params });
    return response.data;
  }

  async getAccountSummary() {
    const response = await api.get('/accounts/summary');
    return response.data;
  }

  async calculateInterest(accountId) {
    const response = await api.post(`/accounts/${accountId}/calculate-interest`);
    return response.data;
  }
}

const accountService = new AccountService();
export default accountService;
